
import Button from '../../../components/base/Button';
import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const images = [
    'https://shabell.jp/images/saoriandou.jpg',
    'https://static.readdy.ai/image/decb7f2cf40f646f7f9a65a0d9d7f813/8067ad09b6c8ffdbb870cd2d8ef6b5df.png',
    'https://static.readdy.ai/image/decb7f2cf40f646f7f9a65a0d9d7f813/8e8b75b05a532267148d89afd28632e0.png'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat transition-all duration-1000"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('${images[currentImageIndex]}')`,
        backgroundPosition: currentImageIndex === 0 ? 'center top' : 'center center'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            声で心を繋ぎ、<br />
            舞台で夢を紡ぐ
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
            アナウンサー×舞台女優、<br />
            2つの顔で「表現する」を追求します
          </p>
          <div className="mb-12">
            <h2 className="text-2xl md:text-3xl font-semibold mb-8" style={{ fontFamily: '"Pacifico", serif' }}>
              安藤 紗織 | Saori Ando
            </h2>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg"
              onClick={() => scrollToSection('works')}
            >
              実績を見る
            </Button>
            <Button 
              variant="outline"
              size="lg"
              onClick={() => scrollToSection('contact')}
              className="border-white text-white hover:bg-white hover:text-black"
            >
              お問い合わせ
            </Button>
          </div>
        </div>
      </div>
      
      {/* Image indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentImageIndex(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentImageIndex ? 'bg-white' : 'bg-white/50'
            }`}
          />
        ))}
      </div>
    </section>
  );
}
